import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Get user_type from localStorage (set before redirect)
        const userType = localStorage.getItem('sfretire_auth_user_type') || 'retraite';
        localStorage.removeItem('sfretire_auth_user_type');

        // Send session_id to our backend (session exchange happens server-side)
        const backendResponse = await fetch(`${API_URL}/api/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            session_id: sessionId,
            user_type: userType
          })
        });

        if (!backendResponse.ok) {
          throw new Error('Failed to process auth');
        }

        const userData = await backendResponse.json();

        // Store user data
        localStorage.setItem('sfretire_token', userData.token);
        localStorage.setItem('sfretire_user', JSON.stringify(userData.user));

        // Clear the hash from URL and redirect
        window.history.replaceState(null, '', window.location.pathname);
        
        // Redirect based on user type
        if (userType === 'entreprise') {
          navigate('/dashboard/entreprise');
        } else {
          navigate('/dashboard/retraite');
        }

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
